//配置全局访问接口地址
// let commonUrl = "http://47.92.238.16:120/";
let commonUrl = "https://lc.e0ziwg.top/";


let baseUrl = {
    commonUrl
}

export default baseUrl